const PRODUCTION_ORIGIN = "https://book.withsplice.com";
const STAGING_ORIGIN = "https://book-staging.withsplice.com";

function stripTrailingSlash(value: string): string {
  return value.replace(/\/$/, "");
}

function viteSiteUrl(): string | undefined {
  try {
    const value = import.meta.env.VITE_SITE_URL;
    return typeof value === "string" && value.length > 0 ? value : undefined;
  } catch {
    return undefined;
  }
}

function viteApiBaseUrl(): string | undefined {
  try {
    const value = import.meta.env.VITE_API_BASE_URL;
    return typeof value === "string" && value.length > 0 ? value : undefined;
  } catch {
    return undefined;
  }
}

function processEnvValue(name: string): string | undefined {
  if (typeof process === "undefined") return undefined;
  const value = process.env[name];
  return value && value.length > 0 ? value : undefined;
}

function configuredSiteUrl(): string | undefined {
  const raw =
    viteSiteUrl() ||
    processEnvValue("VITE_SITE_URL") ||
    processEnvValue("SITE_URL");
  return raw ? stripTrailingSlash(raw) : undefined;
}

function apiBaseUrl(): string {
  return viteApiBaseUrl() || processEnvValue("VITE_API_BASE_URL") || "";
}

function originFromApiBase(apiBase: string): string {
  if (apiBase.includes("api.withsplice.com") && !apiBase.includes("staging")) {
    return PRODUCTION_ORIGIN;
  }
  return STAGING_ORIGIN;
}

export function bookingSiteOrigin(): string {
  if (typeof window !== "undefined" && window.location?.origin) {
    return stripTrailingSlash(window.location.origin);
  }

  return configuredSiteUrl() || originFromApiBase(apiBaseUrl());
}

export function bookingSiteBaseUrl(): string {
  return `${bookingSiteOrigin()}/`;
}
